import { Suspense } from "react";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import BrandCardContainer from "./BrandCardContainer";
import BrandFinderPlugin from "./BrandFinderPlugin";
import { Finder2 as Finder } from "../../../../../../modules/finder";
import * as UI from "../../../../../../modules/ui-kit";


const Styled = styled.div`
    align-items: flex-end;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
`;

export default function BrandSelector(props) {
    const { disabled, onChange, value } = props;

    const [Dialog, open, close] = useDialog();

    function onSelect(brand) {
        onChange(brand);
        close();
    }

    return (
        <Styled>
            {
                value && (
                    <Suspense fallback={ <UI.Bone height="1.6rem" width="16rem" /> }>
                        <BrandCardContainer
                            id={ value }
                        />
                    </Suspense>
                )
            }
            <UI.Button
                $size="large"
                disabled={ disabled }
                onClick={ open }
            >
                { value ? "Change" : "Select" } Brand
            </UI.Button>
            <Dialog>
                <Finder placeholder="Search for a Brand">
                    <BrandFinderPlugin
                        onSelect={ onSelect }
                    />
                </Finder>
            </Dialog>
        </Styled>
    );
}
